const stripTrailingSlashes = (s) => s.replace(/\/+$/, '');

const fromEnv = (process.env.REACT_APP_API_BASE || '').trim();

export const API_BASE = stripTrailingSlashes(
  fromEnv !== ''
    ? fromEnv
    : `${window.location.protocol}//${window.location.host}/api`
);
